<template>
  <div class="user-form-permissions" v-if="permissions.length">
  
    <label class="label" style="margin-bottom:15px;">{{ label }}</label>

    <b-field :horizontal="horizontal">
      <div
        class="columns is-multiline permissions"
        :class="{ 'scrollable-hidden': scrollable }"
        :style="{ height: scrollable && height ? `height: ${height}px` : '' }"
      >
        <div
          class="column is-12 permission"
          v-for="permission in permissions"
          :key="permission.id"
        >
          <b-checkbox
            :native-value="permission.id"
            v-model="checkedPermissions"
          >
            {{ permission.name }}
          </b-checkbox>
        </div>
      </div>
    </b-field>
  </div>
</template>

<script>
import { PermissionService } from "@/services/permission.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";

export default {
  props: {
    label: {
      type: String,
      default: "Permissions"
    },
    checked: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => {}
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number
    }
  },
  data: () => ({
    permissionService: PermissionService,
    permissions: [],
    checkedPermissions: []
  }),
  mounted() {
    this.fetchPermissions();
  },
  watch: {
    checked(checked) {
      this.checkedPermissions = checked;
    },
    checkedPermissions(checked) {
      this.$emit("update:checked", checked);
    }
  },
  methods: {
    async fetchPermissions() {
      const response = await this.permissionService.all(this.params);
      this.permissions = JsonDenormalizer.denormalize(response);
    }
  }
};
</script>

<style lang="scss" scoped>
.permissions {
  margin-top: -5px;
  margin-right: 0;
}
.permission {
  padding: 5px 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Permission/PermissionCheckboxes.vue